import { Badge, ListGroupItem } from "react-bootstrap";
import CommonUtils from "../../utils/common";

const DashTicketsListItem = ({ticket}) => {

    const UTILS = new CommonUtils(); // Utils functions

    // color scheme
    const color = ticket.stage_id[0] === 289 ? "energo": ticket.stage_id[0] === 287 ? "violet" : ticket.stage_id[0] === 286 ? "warning" : "secondary";

    // gui
    return (
        <ListGroupItem 
            key={ticket.id} 
            action 
            href={`/dashboard/support/${ticket.id}`}
        >
            <div className="d-flex justify-content-between">
                <Badge className={ticket.stage_id[0] === 287 ? "pulse":null} bg={color}>{ticket.stage_id[1]}</Badge>
                <small>{UTILS.dateToEuFormat(ticket.create_date)}</small>
            </div>
            <p className="mt-1">{ticket.name} (#{ticket.id})</p>
        </ListGroupItem>
    )
}
export default DashTicketsListItem;